import { render, staticRenderFns } from "./DreProductsTable.vue?vue&type=template&id=2dff4d61&scoped=true"
import script from "./DreProductsTable.vue?vue&type=script&lang=js"
export * from "./DreProductsTable.vue?vue&type=script&lang=js"
import style0 from "./DreProductsTable.vue?vue&type=style&index=0&id=2dff4d61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff4d61",
  null
  
)

export default component.exports